module.exports = __webpack_public_path__ + "static/media/review@2x.399b68a5.png";